import { motion, useViewportScroll, useTransform } from 'framer-motion'
import { useState, useRef, useEffect } from 'react'

// Components
import { Section, Image, Button, useMaxWidth } from '@tracklib/kit'

import styles from './beatbattle.css'

export type BeatBattleProps = {
  value: {
    image: number
    image_mobile_override?: number
    image_width: number
    image_height: number
    background_image: number
    background_image_mobile_override?: number
    link_text: string
    link_url: string
  }
}

const BeatBattle = ({
  value: {
    image,
    image_mobile_override,
    image_width,
    image_height,
    background_image,
    background_image_mobile_override,
    link_text,
    link_url,
  },
}: BeatBattleProps): JSX.Element => {
  const [elementTop, setElementTop] = useState(0)
  const ref = useRef<HTMLDivElement>(null)
  const isSmall = useMaxWidth()
  const textRatio = image_height / (image_width / 100)

  const { scrollY } = useViewportScroll()

  const y = useTransform(scrollY, [elementTop + (isSmall ? 15 : 5), elementTop], [0, -1], {
    clamp: false,
  })

  useEffect(() => {
    const element = ref.current
    if (element) {
      setElementTop(element.offsetTop)
    }
  }, [ref])

  return (
    <div ref={ref}>
      <Section className={styles.wrapper} contentClassName={styles.sectionContent}>
        <div className={styles.parallaxContainer}>
          <motion.div className={styles.image} style={{ y }}>
            <Image
              image={isSmall && background_image_mobile_override ? background_image_mobile_override : background_image}
              alt="Beat Battle"
              absolute
              sizes="100vw"
            />
          </motion.div>
        </div>
        <div className={styles.content} style={{ width: +image_width }}>
          <div style={{ maxWidth: +image_width, paddingBottom: `${textRatio}%` }} className={styles.text}>
            <Image image={isSmall && image_mobile_override ? image_mobile_override : image} alt="Beat Battle" absolute png />
          </div>
          {link_url && (
            <Button variant="white" to={link_url}>
              {link_text}
            </Button>
          )}
        </div>
      </Section>
    </div>
  )
}

export default BeatBattle
